import React, { useEffect, useState } from "react";
import { Card } from "./components/card";
import { LuX } from "react-icons/lu";
import { Button } from "./components/button";

export default function LiveChatPrompt({ requiredScrollPercent = 0 }) {
  const [visible, setVisible] = useState(false);
  const [timerPassed, setTimerPassed] = useState(false);
  const [meetsScroll, setMeetsScroll] = useState(requiredScrollPercent === 0);

  useEffect(() => {
    const t = setTimeout(() => setTimerPassed(true), 2000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (requiredScrollPercent === 0) {
      setMeetsScroll(true);
      return;
    }
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      const scrolledPct = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
      setMeetsScroll(scrolledPct >= requiredScrollPercent);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [requiredScrollPercent]);

  useEffect(() => {
    if (timerPassed && meetsScroll) {
      setVisible(true);
    }
  }, [timerPassed, meetsScroll]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Card className="relative p-3 bg-white/90 dark:bg-[#1A1A1A]/95 border border-white/20 shadow-xl max-w-[240px]">
        <button
          aria-label="Close"
          onClick={() => setVisible(false)}
          className="absolute top-0.5 right-0.5 text-gray-500 hover:text-gray-700"
        >
          <LuX className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-2">
          <div>
            <p className="text-sm font-medium text-gray-900 dark:text-white mb-2">Ask a question</p>
            <a
              href="https://t.me/DotAds_Bot?start=69418db285d5edf0070da486"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button size="sm" className="gap-2 bg-gradient-to-r from-[#9B5CFF] to-[#EC4899] hover:from-[#8B4CFF] hover:to-[#DB2777] text-white">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="#229ED9">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.693-1.653-1.124-2.678-1.8-1.185-.781-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.139-5.062 3.345-.479.329-.913.489-1.302.481-.428-.008-1.252-.241-1.865-.44-.752-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.831-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635.099-.002.321.023.465.14.121.098.155.23.171.324.016.094.036.308.02.475z"/>
                </svg>
                Live Chat
              </Button>
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
}